export enum CompanyType {
	systemAdmin = 1,
}
